//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createSphere } from "./Sphere.js";

export default {
  name: "Sphere",
  props: {
    selected: {
      type: Array
    }
  },
  data() {
    return {
      radius: 5,
      sphere: undefined
    };
  },
  watch: {
    radius(newRadius) {
      this.generate();
    }
  },
  computed: {
    selectedFeatureType(){
      return this.selected[0] ? this.selected[0].type : undefined;
    },
    isCreating() {
      return this.selectedFeatureType !== "Sphere";
    }
  },
  methods: {
    generate() {
      this.sphere = createSphere(this.radius);
      this.$emit("feature:preview", this.sphere.geometry);
    }
  },
  mounted() {
    console.log("Sphere Mounted");
    this.generate();
  }
};
